import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/apiClient';

interface BrandingStatus {
  logo: { mime: string; updatedAt: string | null } | null;
  favicon: { mime: string; updatedAt: string | null } | null;
}

const KEY = ['branding-status'] as const;

export function useBrandingStatus() {
  return useQuery({
    queryKey: KEY,
    queryFn: () => api.get<BrandingStatus>('/api/branding/status'),
    staleTime: 5 * 60 * 1000,
  });
}

export function useInvalidateBranding() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: KEY });
}

/** URL логотипа с cache-busting по updatedAt. null → используем встроенный дефолт. */
export function logoUrl(status: BrandingStatus | undefined): string | null {
  if (!status?.logo) return null;
  const v = status.logo.updatedAt ? encodeURIComponent(status.logo.updatedAt) : '1';
  return `/api/branding/logo?v=${v}`;
}

export function faviconUrl(status: BrandingStatus | undefined): string | null {
  if (!status?.favicon) return null;
  const v = status.favicon.updatedAt ? encodeURIComponent(status.favicon.updatedAt) : '1';
  return `/api/branding/favicon?v=${v}`;
}
